import { z } from 'zod';

export const gamePkSchema = z.object({ gamePk: z.coerce.number() });
